import { Box } from "@twilio-paste/core/box";
import { Separator } from "@twilio-paste/core/separator";
import { Text } from "@twilio-paste/core/text";

import { ChatActionCardProps } from "./definitions";

const ChatActionCard = ({
  children,
  heading,
  headingIcon,
  inactive = false,
}: ChatActionCardProps) => {
  return (
    <Box
      backgroundColor={inactive ? "colorBackgroundWeak" : undefined}
      borderColor="colorBorderWeaker"
      borderRadius="borderRadius20"
      borderStyle="solid"
      borderWidth="borderWidth10"
      padding="space60"
      flexGrow={1}
    >
      <Box display="flex" marginBottom="space30">
        {headingIcon}
        <Text
          as="p"
          marginLeft="space20"
          fontSize="fontSize40"
          fontWeight="fontWeightBold"
        >
          {heading}
        </Text>
      </Box>

      <Separator orientation="horizontal" />
      <Box marginTop="space40">{children}</Box>
    </Box>
  );
};

export default ChatActionCard;
